/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Gyms_SwitchedInputs */

const en_us2_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gym in use: ${i?.name}`)
};

const pt_br2_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Academia em uso: ${i?.name}`)
};

const es_419_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gimnasio en uso: ${i?.name}`)
};

const pt_pt2_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ginásio em uso: ${i?.name}`)
};

const fr_fr2_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salle active : ${i?.name}`)
};

const de_de2_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktives Studio: ${i?.name}`)
};

const it_it2_gyms_switched = /** @type {(inputs: Gyms_SwitchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palestra in uso: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Gym in use: {name}" |
*
* @param {Gyms_SwitchedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_switched = /** @type {((inputs: Gyms_SwitchedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_SwitchedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_switched(inputs)
	if (locale === "es-419") return es_419_gyms_switched(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_switched(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_switched(inputs)
	if (locale === "de-DE") return de_de2_gyms_switched(inputs)
	if (locale === "it-IT") return it_it2_gyms_switched(inputs)
	return en_us2_gyms_switched(inputs)
});
export { gyms_switched as "gyms.switched" }